import { render } from "./Index-home.vue?vue&type=template&id=01f7e475"
import script from "./Index-home.vue?vue&type=script&lang=js"
export * from "./Index-home.vue?vue&type=script&lang=js"

import "./Index-home.vue?vue&type=style&index=0&id=01f7e475&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__